import React, { useState } from 'react';
import AsyncSelect from '../Select/AsyncSelect';
import useTranslation from '../../../Hooks/useTranslation';
import { SelectValue } from '../Select/Select';
import {
	WorkplaceMedicalProcedure,
	useLazyGetWorkplaceMedicalProceduresWhispererQuery,
} from '../../../graphql/graphql';
import { SingleValue } from 'react-select';
import { FieldError } from 'react-hook-form';

interface MedicalProceduresSelectProps {
	value?: SelectValue;
	onChange?: (newValue: SingleValue<SelectValue>) => void;
	error?: FieldError;
}

const WorkplaceMedicalProceduresSelect = ({
	value,
	onChange,
	error,
}: MedicalProceduresSelectProps) => {
	const [searchTimeout, setSearchTimeout] = useState<number | undefined>(
		undefined,
	);
	const { t } = useTranslation();
	const [getWorkplaceMedicalProcedures] =
		useLazyGetWorkplaceMedicalProceduresWhispererQuery();

	const loadOptions = (
		inputValue: string,
		callback: (options: SelectValue[]) => void,
	) => {
		if (searchTimeout) {
			clearTimeout(searchTimeout);
		}

		const loadData = async () => {
			const { workplaceMedicalProcedures } =
				await getWorkplaceMedicalProcedures({
					where: {
						fulltext: inputValue,
					},
				}).unwrap();

			const t: SelectValue[] = [];

			console.log(workplaceMedicalProcedures);

			if (workplaceMedicalProcedures?.data?.length) {
				workplaceMedicalProcedures?.data.forEach(workplaceMedicalProcedure => {
					t.push({
						label: workplaceMedicalProcedure.medicalProcedure.formattedName,
						value: workplaceMedicalProcedure.medicalProcedure.id,
					});
				});
			}

			callback(t);
		};

		setSearchTimeout(
			setTimeout(() => {
				loadData();
			}, 500),
		);
	};

	return (
		<AsyncSelect
			onSearch={loadOptions}
			placeholder={t('base.shared.pick')}
			noOptionsMessage={t('base.startTyping')}
			value={value}
			onChange={onChange}
			error={error}
			portal={true}
		/>
	);
};

export default WorkplaceMedicalProceduresSelect;
